export enum HeaderType {
    text = 'Text',
    primary = 'Primary',
    white = 'White',
    summary = 'Summary',
    grey = 'Grey'
}